module.exports = __webpack_public_path__ + "static/media/driver.9e92bcd0.png";